import React, { useMemo } from 'react';
import { Link, useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button';

import { actions } from '../../store/reducers/authentication';
import AuthLayout from '../../components/Layout/AuthLayout';

const mstp = ({ authentication }) => ({ authentication });
const step = 1;

const ResetPassword = ({
  authentication: { resetRequestSuccedded, resetRequestError, resetRequestStatus, submitting },
  requestResetPassword,
  resetPassword
}) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { app } = useParams();
  const [_, confirmationToken] = pathname.split("/password/reset/");

  const getLogInLink = () => {
    if (app) {
      return `/${app}/login`;
    }

    return '/login';
  }

  return (
    <AuthLayout
      app={app}
      step={step}
      title={
        !confirmationToken ?
          resetRequestSuccedded ? 'Thank you' : 'Reset Password'
          : resetRequestSuccedded ? 'Password updated' : 'Create Password'
      }
      subTitle={
        !confirmationToken ?
          resetRequestSuccedded ? 'A password reset link has been sent to your email address. If you can’t find the message in your inbox, please check your spam folder!' : 'Please enter your email, to get a link and request a new password.'
          : resetRequestSuccedded ? 'Your password has been updated, click in the button below to log in.' : 'Please set up your new password.'
      }
    >
      {!resetRequestSuccedded && !confirmationToken ? <Form layout="vertical" onFinish={requestResetPassword}>
        <Form.Item label={t("Email")} name="email" rules={[
          {
            required: true,
            message: t("errors::email should not be empty"),
          },
          {
            pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
            message: t('errors::email is not valid'),
          },
        ]}>
          <Input
            size="large"
            placeholder={t("Email")}
            className="email"
          />
        </Form.Item>
        {resetRequestError ? (
          <div
            className="ant-form-item-explain errors-cont no-pt"
            style={{ color: '#ff4d4f' }}>
            {t(resetRequestError)}
          </div>
        ) : null}
        <div className="buttons">
          <Button type="primary" size="large" block htmlType="submit" disabled={submitting} className="normal-br">
            {t("Get Link")}
          </Button>
          <Link to={getLogInLink()}>
            <Button size="large" block htmlType="submit" className="normal-br default">
              {t("Back")}
            </Button>
          </Link>
        </div>
      </Form> : null}
      {!resetRequestSuccedded && confirmationToken ? <Form
        layout="vertical"
        onFinish={resetPassword}
        initialValues={{ passConfirmationToken: confirmationToken }}>
        <Form.Item name="passConfirmationToken" style={{ display: 'none' }}>
          <Input
            size="large"
            type="hidden" />
        </Form.Item>
        <Form.Item label={t("Enter password")} name="password" rules={[
          {
            required: true,
            message: t("errors::password should not be empty"),
          },
        ]}>
          <Input.Password
            size="large"
            placeholder={t("••••••••")}
            type="password"
            className="email" />
        </Form.Item>
        <Form.Item
          label={t("Confirm password")}
          name="confirmPassword"
          dependencies={['password']}
          rules={[
            {
              required: true,
              message: t("errors::password should not be empty"),
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(t('errors::passwordNotMatch'));
              },
            }),
          ]}>
          <Input.Password
            size="large"
            placeholder={t("••••••••")}
            type="password"
            className="email" />
        </Form.Item>
        <div className="buttons">
          <Button type="primary" size="large" block htmlType="submit" loading={submitting} className="normal-br">
            {t("Reset Password")}
          </Button>
        </div>
      </Form> : null}

      {resetRequestSuccedded && confirmationToken ? (
        <div className="buttons">
          <Link to={getLogInLink()}>
            <Button size="large" type="primary" block className="normal-br default">
              {t("Log In")}
            </Button>
          </Link>
        </div>
      ) : null}
    </AuthLayout>
  );
}

export default connect(mstp, actions)(ResetPassword);